import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ModalErrorIcon extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    width: 80,
    height: 80,
  };

  render() {
    const { width, height, className } = this.props;

    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 80"
        preserveAspectRatio="xMinYMin"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0H80V80H0z" />
          <g transform="translate(11 12)">
            <circle cx="21" cy="28" r="21" fill="#E8E8E8" />
            <path
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M31 19L31 34"
            />
            <circle cx="31" cy="40.5" r="1.5" fill="#000" />
            <path
              stroke="#000"
              strokeWidth="2"
              d="M32.422 5.796c-.73-.393-1.549-.453-2.284-.232-.735.22-1.387.721-1.78 1.45L7.056 46.579c-.235.437-.358.926-.358 1.422 0 .828.336 1.578.879 2.121.542.543 1.292.879 2.12.879h42.607c.497 0 .985-.123 1.422-.359.73-.392 1.231-1.044 1.452-1.779.22-.735.16-1.555-.232-2.284L33.64 7.015c-.278-.517-.702-.941-1.219-1.22z"
            />
          </g>
        </g>
      </svg>
    );
  }
}

export default ModalErrorIcon;
